<app-nav-bar class = "ui-nav-bar-container" *ngIf = "withNavBar"></app-nav-bar>
<div class = "ui-router-container">
    <router-outlet></router-outlet>
</div>
